import { useIsMobile } from "@components/mediaQuery/useIsMobile";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import DonutChartPeplink from "../../charts/DonutChartPeplink";
import SplineAreaChartPeplink from "../../charts/SplineAreaChartPeplink";
import SplineAreaChartPeplinkQuality from "../../charts/SplineAreaChartPeplinkQuality";
import CustomAccordion from "../../common/CustomAccordion";

const Peplink = () => {
	const dispatch = useDispatch();
	const navigate = useNavigate();

	const hasPeplink = useSelector((state) => state.modules.vessels.peplink.hasPeplink);
	const peplinkBandwidthWan = useSelector((state) => state.modules.vessels.peplink?.wan1);
	const peplinkBandwidthWan2 = useSelector((state) => state.modules.vessels.peplink?.wan2);
	const peplinkCellular = useSelector((state) => state.modules.vessels.peplink.cellular);
	const peplinkQuality = useSelector((state) => state.modules.vessels.peplink.quality);
	const loadingVesselDetailsStarlink = useSelector(
		(state) => state.modules.vessels.peplink.loading,
	);
	const WansStatus = useSelector((state) => state.modules.vessels.peplink.status);

	const CellularUsagePeplink = peplinkCellular[0]?.data?.data?.stats;

	const [openAccordions, setOpenAccordions] = useState({});

	useEffect(() => {
		const initialOpenState = {};
		peplinkCellular[0]?.data?.data.forEach((_, index) => {
			initialOpenState[`cellular-${index}`] = true;
			initialOpenState[`usage-${index}`] = true;
		});

		WansStatus?.data?.forEach((TelemetryData, index) => {
			initialOpenState[`wans-${index}`] = true;
		});

		peplinkQuality[0]?.data.data.forEach((_, index) => {
			initialOpenState[`quality-${index}`] = true;
		});

		setOpenAccordions(initialOpenState);
	}, [peplinkCellular, WansStatus, peplinkQuality]);

	const toggleAccordion = (id) => {
		setOpenAccordions((prevState) => ({
			...prevState,
			[id]: !prevState[id],
		}));
	};
	const isMobile = useIsMobile();

	return (
		<>
			<div>
				{loadingVesselDetailsStarlink ? (
					<div className="flex h-64 items-center justify-center">
						<div className="h-32 w-32 animate-spin rounded-full border-gray-700 border-t-2 border-b-2"></div>
					</div>
				) : (
					// ) : hasPeplink ? (
					<div className="grid grid-cols-1 gap-4 md:grid-cols-1">
						{/* {peplinkBandwidthWan[0]?.data.map((PeplinkData, index) => (
              <div key={index} className="chart-row-50">
                <div className="chart-column w-50">
                  <CustomAccordion isMobile={isMobile}
                    title={`${peplinkBandwidthWan[0]?.type} - ${PeplinkData?.serial_number}`}
                  >
                    <SplineAreaChartPeplink
                      data={PeplinkData?.usages} 
                      type={peplinkBandwidthWan[0]?.type}
                      id={`${peplinkBandwidthWan2[0]?.id}`}
                      dispatch={dispatch}
                      navigate={navigate}
                      selected={"Wan"}
                    />
                    <StatsUsage
                      min_up={PeplinkData.stats?.min_up} 
                      max_up={PeplinkData.stats?.max_up}
                      min_down={PeplinkData.stats?.min_down}
                      max_down={PeplinkData.stats?.max_down}
                      last_down={PeplinkData.stats?.last_down}
                      last_up={PeplinkData.stats?.last_up}
                    ></StatsUsage>
                  </CustomAccordion>
                </div>
              </div>
            ))}
            {peplinkBandwidthWan2[0]?.data.map((PeplinkData, index) => (
              <div key={index} className="chart-row-100">
                <div className="chart-column w-100">
                  <CustomAccordion isMobile={isMobile}
                    title={`${peplinkBandwidthWan2[0]?.type} - ${PeplinkData?.serial_number}`}
                  >
                    <SplineAreaChartPeplink
                      data={PeplinkData?.usages}
                      type={peplinkBandwidthWan2[0]?.type}
                      id={`${peplinkBandwidthWan2[0]?.id}`}
                      dispatch={dispatch}
                      navigate={navigate}
                      selected={"Wan2"}
                    />
                    <StatsUsage
                      min_up={PeplinkData?.stats?.min_up}
                      max_up={PeplinkData?.stats?.max_up}
                      min_down={PeplinkData?.stats?.min_down}
                      max_down={PeplinkData?.stats?.max_down}
                      last_down={PeplinkData?.stats?.last_down}
                      last_up={PeplinkData?.stats?.last_up}
                    ></StatsUsage>
                  </CustomAccordion>
                </div>
              </div>
            ))} */}
						<div className="grid grid-cols-1 gap-4 md:grid-cols-1">
							{peplinkCellular[0]?.data?.data.length > 0 ? (
								peplinkCellular[0]?.data?.data.map((PeplinkData, index) => (
									<div key={index} className="chart-row-100">
										<div className="chart-column w-100">
											<CustomAccordion
												title={`${peplinkCellular[0]?.type} - ${PeplinkData?.serial_number}`}
												id={`cellular-${index}`} // Unique ID for each accordion
												isOpen={openAccordions[`cellular-${index}`] || false}
												toggleAccordion={() => toggleAccordion(`cellular-${index}`)}
												classCss={`${openAccordions[`cellular-${index}`]} border-0`}
												isMobile={isMobile}
											>
												<SplineAreaChartPeplink
													data={PeplinkData?.usages}
													type={peplinkCellular[0]?.type}
													id={`${peplinkCellular[0]?.id}`}
													dispatch={dispatch}
													navigate={navigate}
													selected={"Cellular"}
												/>
											</CustomAccordion>
										</div>
									</div>
								))
							) : (
								<div className="flex w-full items-start space-x-3 rounded-lg border-yellow-500 border-l-4 bg-yellow-100 p-4 shadow-lg">
									<div className="flex items-center justify-center rounded-full text-white">
										<svg
											className="h-6 w-6 text-yellow-500"
											xmlns="http://www.w3.org/2000/svg"
											fill="currentColor"
											viewBox="0 0 24 24"
										>
											<path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"></path>
										</svg>
									</div>
									<div className="text-yellow-900">
										<p className="font-semibold text-yellow-800">
											No Bandwidth Cellular Usage Available
										</p>
									</div>
								</div>
							)}
						</div>

						<div className="grid grid-cols-1 gap-4 lg:grid-cols-2">
							{WansStatus && WansStatus?.data?.length > 0 ? (
								WansStatus?.data?.map((itemData, index) => (
									<div
										key={index}
										className={`chart-column w-50 ${openAccordions[`wans-${index}`] ? "bg-navbar-bg" : ""} rounded-lg border-t-0`}
									>
										<CustomAccordion
											title={`Peplink Wans Status - ${itemData?.serial_number}`}
											id={`wans-${index}`} // Unique ID for each accordion
											isOpen={openAccordions[`wans-${index}`] || false}
											toggleAccordion={() => toggleAccordion(`wans-${index}`)}
											classCss={`${openAccordions[`wans-${index}`]} border-0`}
											isMobile={isMobile}
										>
											<div className="w-full space-y-2">
												{itemData?.usages && itemData?.usages.length > 0 ? (
													itemData?.usages.map((item, usageIndex) => (
														<div
															key={usageIndex}
															className="flex w-full flex-col space-y-2 rounded-lg bg-blue-gray bg-opacity-20 p-3"
														>
															<div className="flex w-full items-center justify-between text-light-white">
																<div>{item?.name}</div>
																<div>
																	<span className="me-2 rounded bg-blue-gray p-2 px-2.5 py-0.5 font-medium text-light-white text-xs">
																		{item?.status}
																	</span>
																</div>
															</div>
															{item?.ip && (
																<div className="flex items-start">
																	<span className="text-white text-xs">(IP: {item?.ip})</span>
																</div>
															)}
															{item?.eSIM && (
																<div className="flex items-start">
																	<span className="text-gray-300 text-xs">
																		(eSIM: {item?.eSIM})
																	</span>
																</div>
															)}
														</div>
													))
												) : (
													<p>No status available</p>
												)}
											</div>
										</CustomAccordion>
									</div>
								))
							) : (
								<div className="flex w-full items-start space-x-3 rounded-lg border-yellow-500 border-l-4 bg-yellow-100 p-4 shadow-lg">
									<div className="flex items-center justify-center rounded-full text-white">
										<svg
											className="h-6 w-6 text-yellow-500"
											xmlns="http://www.w3.org/2000/svg"
											fill="currentColor"
											viewBox="0 0 24 24"
										>
											<path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"></path>
										</svg>
									</div>
									<div className="text-yellow-900">
										<p className="font-semibold text-yellow-800">No Peplink Wans Data Available</p>
									</div>
								</div>
							)}
							{peplinkCellular[0]?.data?.data?.length > 0 ? (
								peplinkCellular[0]?.data?.data.map((usageData, index) => (
									<div
										key={index}
										className={`chart-column w-50 ${openAccordions[`usage-${index}`]} rounded-lg border-t-0`}
									>
										<CustomAccordion
											title={`Cellular Usage Percent - ${usageData?.serial_number}`}
											id={`usage-${index}`} // Unique ID for each accordion
											isOpen={openAccordions[`usage-${index}`] || false}
											toggleAccordion={() => toggleAccordion(`usage-${index}`)}
											classCss={`${openAccordions[`usage-${index}`]} border-0`}
											isMobile={isMobile}
										>
											{usageData?.stats?.subscription === null ? (
												<div className="flex h-48 items-center justify-center">
													<span className="font-normal text-gray-400 text-sm leading-tight">
														No Cellular Usage Available
													</span>
												</div>
											) : (
												<DonutChartPeplink
													allowance={usageData?.stats?.subscriptions[0]?.allowance_gb}
													totalUsage={usageData?.stats?.allowance_gb}
													alerts={usageData?.alerts ?? []}
												/>
											)}
										</CustomAccordion>
									</div>
								))
							) : (
								<div className="flex w-full items-start space-x-3 rounded-lg border-yellow-500 border-l-4 bg-yellow-100 p-4 shadow-lg">
									<div className="flex items-center justify-center rounded-full text-white">
										<svg
											className="h-6 w-6 text-yellow-500"
											xmlns="http://www.w3.org/2000/svg"
											fill="currentColor"
											viewBox="0 0 24 24"
										>
											<path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"></path>
										</svg>
									</div>
									<div className="text-yellow-900">
										<p className="font-semibold text-yellow-800">
											No Cellular Usage Percent Data Available
										</p>
									</div>
								</div>
							)}{" "}
						</div>
						<div className="grid grid-cols-1 gap-4 md:grid-cols-1">
							{peplinkQuality[0]?.data?.data?.length > 0 ? (
								peplinkQuality[0]?.data?.data.map((PeplinkData, index) => (
									<div key={index} className="chart-row-50">
										<div className="chart-column w-50">
											<CustomAccordion
												title={`${peplinkQuality[0]?.type} - ${PeplinkData?.serial_number}`}
												id={`quality-${index}`} // Unique ID for each accordion
												isOpen={openAccordions[`quality-${index}`] || false}
												toggleAccordion={() => toggleAccordion(`quality-${index}`)}
												classCss={`${openAccordions[`quality-${index}`] && "bg-[#1F2A37]"} border-0`}
												isMobile={isMobile}
											>
												<SplineAreaChartPeplinkQuality
													data={PeplinkData?.usages}
													type={peplinkQuality[0]?.type}
													id={`${peplinkQuality[0]?.id}`}
													dispatch={dispatch}
													navigate={navigate}
												/>
											</CustomAccordion>
										</div>
									</div>
								))
							) : (
								<div className="flex w-full items-start space-x-3 rounded-lg border-yellow-500 border-l-4 bg-yellow-100 p-4 shadow-lg">
									<div className="flex items-center justify-center rounded-full text-white">
										<svg
											className="h-6 w-6 text-yellow-500"
											xmlns="http://www.w3.org/2000/svg"
											fill="currentColor"
											viewBox="0 0 24 24"
										>
											<path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"></path>
										</svg>
									</div>
									<div className="text-yellow-900">
										<p className="font-semibold text-yellow-800">
											No Cellular Signal Quality Data Available
										</p>
									</div>
								</div>
							)}
						</div>
					</div>

					// ) : (
					//   <div className="flex justify-center items-center h-64">
					//     <span className="text-gray-400 leading-tight text-sm font-normal">
					//       No Peplink
					//     </span>
					//   </div>
				)}
			</div>
		</>
	);
};

export default Peplink;
